"use client";
import { ArrowLeft } from "lucide-react";
import { Button } from "../ui/button";
import { useRouter } from "next/navigation";

export default function GlobalBackButton() {
  const router = useRouter();

  return (
    <Button variant="ghost" onClick={() => router.back()} className="hidden md:flex">
      <ArrowLeft strokeWidth={3} />
    </Button>
  );
}
